<form
  #form="ngForm"
  novalidate
  class="flex flex-col gap-1"
>
  @let store = offshoreOperationalStore;
  @let vm = offshoreReportStore.vm();
  <h1 class="mb-4 self-center text-xl">Crew and Passengers</h1>

  <nsp-number-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'numCrew')"
    id="numCrew"
    name="numCrew"
    label="Number of Crew"
    [required]="vm.isFieldRequired(tabId, sectionId, 'numCrew')"
    [labelWidthPercentage]="33"
    [value]="store.crewAndPassengers?.()?.numCrew?.value"
    [ngModel]="store.crewAndPassengers?.()?.numCrew?.value"
  />

  <nsp-number-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'numMarineCrew')"
    id="numMarineCrew"
    name="numMarineCrew"
    label="Number of Marine Crew"
    [required]="vm.isFieldRequired(tabId, sectionId, 'numMarineCrew')"
    [labelWidthPercentage]="33"
    [value]="store.crewAndPassengers?.()?.numMarineCrew?.value"
    [ngModel]="store.crewAndPassengers?.()?.numMarineCrew?.value"
  />

  <nsp-number-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'numContractors')"
    id="numContractors"
    name="numContractors"
    label="Number of Contractors"
    [required]="vm.isFieldRequired(tabId, sectionId, 'numContractors')"
    [labelWidthPercentage]="33"
    [value]="store.crewAndPassengers?.()?.numContractors?.value"
    [ngModel]="store.crewAndPassengers?.()?.numContractors?.value"
  />

  <nsp-number-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'numClients')"
    id="numClients"
    name="numClients"
    label="Number of Clients"
    [required]="vm.isFieldRequired(tabId, sectionId, 'numClients')"
    [labelWidthPercentage]="33"
    [value]="store.crewAndPassengers?.()?.numClients?.value"
    [ngModel]="store.crewAndPassengers?.()?.numClients?.value"
  />

  <nsp-number-input
    *nspVisible="vm.isFieldVisible(tabId, sectionId, 'numPassengers')"
    id="numPassengers"
    name="numPassengers"
    label="Number of Passengers"
    [required]="vm.isFieldRequired(tabId, sectionId, 'numPassengers')"
    [labelWidthPercentage]="33"
    [value]="store.crewAndPassengers?.()?.numPassengers?.value"
    [ngModel]="store.crewAndPassengers?.()?.numPassengers?.value"
  />
</form>
